// RegionRoleTag — レイヤーの行に添える小さな印「置き先」「取った元」
// (範囲の移動・コピーで絵を浮かせている間だけ。docs/_wip/region-move-2026-10-15.md「UI」)。
// 行のコントロールを邪魔しないよう右上に重ね、操作は受けない。親の <li> は `relative`。

import { type RegionLayerRoles, regionRoleTag } from '../../../application/regionMoveFlow.js';

export const RegionRoleTag = ({
  roles,
  layerId,
}: {
  readonly roles: RegionLayerRoles | null | undefined;
  readonly layerId: number;
}): React.ReactNode => {
  const text = regionRoleTag(roles ?? null, layerId);
  if (text === null) return null;
  return (
    <span
      data-testid={`region-role-tag-${layerId}`}
      className="pointer-events-none absolute top-0 right-1 rounded-sm bg-[var(--color-accent)] px-1 text-[9px] font-bold leading-tight text-black"
    >
      {text}
    </span>
  );
};
